module.exports = __webpack_public_path__ + "img/bgSocialInsuranceTransferPolicy.d8192d73.png";